import { Navigate, useLocation } from "react-router";
import { useMe } from "../hooks/useMe";
import { routePermissions } from "../config/routePermission";

// eslint-disable-next-line react/prop-types
export const ProtectedRoute = ({ children }) => {
  const { isLoading, isError, data: user } = useMe()
  const location = useLocation();

  if (isLoading) return <div>Loading...</div>
  if (isError) return <Navigate to="/login" replace />

  const role = user?.data?.directorate;
  const position = user?.data?.position;

  const basePath = "/" + location.pathname.split("/")[1];

  const allowedRoles = routePermissions[basePath];

  if (position?.toLowerCase() === "superadmin") {
    return children;
  }

  if (!allowedRoles) {
    return <Navigate to="/" replace />;
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children
};